// @flow strict
import * as React from 'react';

type DotPropsType = {
  active: boolean,
};
const Dot = (props: DotPropsType) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8">
      <circle
        cx="49"
        cy="4"
        r="4"
        transform="translate(-45)"
        fill={props.active ? '#07070C' : '#B4BABB'}
      />
    </svg>
  );
};

export { Dot };
